import {
  LOAD_PLANT_MINING_CONTRACT,
  CREATE_PLANT_MINING_CONTRACT,
  LOAD_PLANT_MINING_CONTRACT_DETAIL,
  UPDATE_PLANT_MINING_CONTRACT,
  UPLOAD_PLANT_MINING_CONTRACT,
  EXPORT_PLANT_MINING_CONTRACT,
  LOAD_SEQ_FOR_SECONDARY_CONTRACT,
  UPDATE_SEQ_FOR_SECONDARY_CONTRACT,
  REMOVE_LISTS,
} from './actions'

const initialState = {
  Lists: [],
  lists_for_edit: [],
  EditList: [],
  total: 1,
  loading: false,
  draw: -1,
  check: true,

  // *manage seq for seconary contract
  secondary_contract_list: [],
  check_secondary_contract_list: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case LOAD_PLANT_MINING_CONTRACT.REQUEST:
      const { loading } = action.payload.data
      return {
        ...state,
        loading: loading || true,
      }

    case LOAD_PLANT_MINING_CONTRACT.SUCCESS:
      const { page, pageSize } = action.payload
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * pageSize
      }
      return {
        ...state,
        Lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case CREATE_PLANT_MINING_CONTRACT.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case CREATE_PLANT_MINING_CONTRACT.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case LOAD_PLANT_MINING_CONTRACT_DETAIL.REQUEST:
      return {
        ...state,
        loading: true,
        check: true,
      }

    case LOAD_PLANT_MINING_CONTRACT_DETAIL.SUCCESS:
      return {
        ...state,
        lists_for_edit: action.payload.listsEdit.data,
        check: false,
        loading: false,
      }

    case UPDATE_PLANT_MINING_CONTRACT.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case UPDATE_PLANT_MINING_CONTRACT.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case UPLOAD_PLANT_MINING_CONTRACT.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case UPLOAD_PLANT_MINING_CONTRACT.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case EXPORT_PLANT_MINING_CONTRACT.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case EXPORT_PLANT_MINING_CONTRACT.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case LOAD_SEQ_FOR_SECONDARY_CONTRACT.REQUEST:
      return {
        ...state,
        secondary_contract_list: [],
        check_secondary_contract_list: true,
      }

    case LOAD_SEQ_FOR_SECONDARY_CONTRACT.SUCCESS:
      return {
        ...state,
        secondary_contract_list: action.payload.lists,
        check_secondary_contract_list: false,
      }

    default:
      return state
  }
}
